import { classed } from "@tw-classed/core";
import React, { type FormHTMLAttributes } from "react";
import { FormHelperText } from "../formHelperText";
import { Checkbox } from "./checkbox.component";
import { FormControl } from "./form-control.component";
import { InputFile } from "./input-file";
import { InputNumeric } from "./input-numeric";
import { InputRadio } from "./input-radio";
import { InputText } from "./input-text.component";
import { Label } from "./label.component";

export type FormProps = FormHTMLAttributes<HTMLFormElement>;

const FormComp = React.forwardRef<HTMLFormElement, FormProps>(({ children, className, ...props }, ref): JSX.Element => {
  const classes = classed();

  return (
    <form {...props} className={classes({ className })} ref={ref}>
      {children}
    </form>
  );
});

export const Form = Object.assign(FormComp, {
  Label,
  Control: FormControl,
  Checkbox,
  InputText,
  InputFile,
  InputNumeric,
  InputRadio,
  TextHelper: FormHelperText,
});
